function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UpdatePriceVue from '../dialogs/UpdatePrice.vue';
import { categoryApi, productsPageApi, deleteProductsApi } from '../../../api';
export default {
  name: 'Product',
  components: {
    UpdatePriceVue: UpdatePriceVue
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      form: {},
      merCateList: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      pageFrom: {
        page: 1,
        limit: 15
      },
      loading: false,
      tableData: {
        list: [],
        total: 0
      },
      UpdatePriceVueRef: null
    };
  },
  methods: {
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this.merCateList = res;
      }).catch(function (res) {
        _this.$message.error(res.message);
      });
    },
    search: function search() {
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.form), {}, {
        customerId: this.id
      });
      productsPageApi(params).then(function (res) {
        _this2.tableData = res;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    openUpdatePrice: function openUpdatePrice(row) {
      this.UpdatePriceVueRef.open(row);
    },
    deleteProduct: function deleteProduct(row) {
      var _this3 = this;
      var customerSupplier = row.customerSupplier,
        products = row.products;
      var params = _objectSpread(_objectSpread(_objectSpread({}, customerSupplier), products), {}, {
        companyId: this.companyId
      });
      deleteProductsApi(params).then(function () {
        _this3.$message.success('移除成功');
        _this3.search();
      });
    }
  },
  computed: {
    categoryId: function categoryId() {
      return this.form.categoryId;
    },
    categoryName: function categoryName() {
      return this.form.categoryName;
    }
  },
  created: function created() {
    this.getCategorySelect();
  },
  watch: {
    id: function id() {
      if (this.id) {
        this.getList();
      }
    }
  },
  mounted: function mounted() {
    this.UpdatePriceVueRef = this.$refs.UpdatePriceVueRef;
    this.getList();
  }
};